import { track } from 'src/client/js/analytics/facade';

export const trackParentNavItem = (menuLabel, linkUrl) => track(
  'Parent NavItem click',
  {
    label: `Parent NavItem: ${menuLabel || linkUrl}`,
    category: 'Nav v3',
  }
);

export const trackChildNavItem = (parentLabel, linkLabel) => track(
  'Child Nav Item click',
  {
    label: `Nav link parent: ${parentLabel} / Nav Link Child: ${linkLabel}`,
    category: 'Nav v3',
  }
);

export const trackMarketingCardItem = (parentLabel, linkLabel) => track(
  'Child Nav Marketing Card Item click',
  {
    label: `Nav link parent: ${parentLabel} / Nav Link Child: ${linkLabel}`,
    category: 'Nav v3',
  }
);

export const trackAdditionalLinks = (linkUrl) => track(
  'Info Nav Item click',
  {
    label: `Nav Link Info: ${linkUrl}`,
    category: 'Nav v3',
  }
);
